import { useTranslation } from 'react-i18next'
import { reject, propEq } from 'ramda'
import { BackButton } from './buttons'
import { useAddendumModal } from './context'
import ListBase from './list-base'
import ModalBase from './modal-base'

const StandardList = () => {
  const { t } = useTranslation()
  const {
    backStep,
    standardAddendums,
    setStandardAddendums,
    standardSelected,
    setStandardSelected,
    isOntario,
    isAlberta
  } = useAddendumModal()

  const showCustomAddendumList = isOntario || isAlberta

  const templates = showCustomAddendumList
    ? reject(propEq('listing_contract_addendum_template_id', '4'), standardAddendums)
    : standardAddendums

  return (
    <ModalBase
      leftWidget={<BackButton back={backStep} />}
      title={t('l.contract.edit.standard_addendum_modal.title', 'Addendums by liv.rent')}
      subtitle={t(
        'l.contract.edit.standard_addendums_description.text',
        'Here are addendum templates created by us. Click into each one to view details.'
      )}
    >
      <ListBase
        templates={templates}
        setTemplates={setStandardAddendums}
        selected={standardSelected}
        setSelected={setStandardSelected}
      />
    </ModalBase>
  )
}

export default StandardList
